import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-zinc-800 bg-zinc-950 py-8 px-6" data-testid="global-footer">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-mono text-xs text-zinc-600">
          © {new Date().getFullYear()} IndieLaunchkit. You own 100% of what you generate.
        </p>
        <div className="flex items-center gap-6 text-sm">
          <Link to="/terms" className="text-zinc-400 hover:text-teal-300 transition-colors duration-200" data-testid="footer-terms-link">
            Terms
          </Link>
          <Link to="/privacy" className="text-zinc-400 hover:text-teal-300 transition-colors duration-200" data-testid="footer-privacy-link">
            Privacy
          </Link>
          <a
            href="mailto:contact@getindielaunchkit.com"
            className="text-zinc-400 hover:text-teal-300 transition-colors duration-200 font-mono text-xs"
            data-testid="footer-contact-email"
          >
            contact@getindielaunchkit.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
